import * as React from "react";
import { Text } from "@uikit";

interface IProps {
  difficulty?: string;
}

const CourseTechnicalDifficulty = ({ difficulty }: IProps) => {
  let rating_score = () => {
    switch (difficulty) {
      case "Easy":
        return 1;
      case "Easy_Moderate":
        return 2;
      case "Moderate":
        return 3;
      case "Moderate_Hard":
        return 4;
      case "Hard":
        return 5;
      default:
        return 0;
    }
  };

  return (
    <div>
      <Text
        element="h3"
        size={17}
        leading={1.3}
        weight="semibold"
        className="mb-[20px]"
        color="black90"
      >
        Technical Difficulty
      </Text>
      <div className="flex gap-2 items-center">
        <div className="flex gap-[4px]">
          {[1, 2, 3, 4, 5].map((star, starIdx) => {
            if (rating_score() >= star) {
              return <div className="w-5 h-2 bg-orange" key={starIdx}></div>;
            }
            return <div className="w-5 h-2 bg-grey4" key={starIdx}></div>;
          })}
        </div>
        {difficulty && (
          <Text size={13} weight="semibold">
            {difficulty.replace("_", "/")}
          </Text>
        )}
      </div>
    </div>
  );
};

export default CourseTechnicalDifficulty;
